export const categories = [
  {
    id: 'keji-shuma',
    name: '科技数码',
    slug: 'keji-shuma',
    description: '中国智造的硬核科技力量，从芯片到终端，展现中国科技自主创新的强大实力',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'jiadian',
    name: '家用电器',
    slug: 'jiadian',
    description: '从白色家电到智能家居，中国家电品牌以卓越品质赢得全球消费者信赖',
    icon: 'ri-home-3-line',
  },
  {
    id: 'meizhuang',
    name: '美妆护肤',
    slug: 'meizhuang',
    description: '东方美学与现代科技融合，中国美妆品牌重新定义亚洲之美',
    icon: 'ri-heart-pulse-line',
  },
  {
    id: 'shipin-yinliao',
    name: '食品饮料',
    slug: 'shipin-yinliao',
    description: '从田间到餐桌，中国食品品牌坚守品质初心，传递地道中国味道',
    icon: 'ri-restaurant-line',
  },
  {
    id: 'fushi-xiebao',
    name: '服饰鞋包',
    slug: 'fushi-xiebao',
    description: '中国设计，全球视野。国潮崛起让世界看到中国时尚的无限可能',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 'qiche',
    name: '新能源车',
    slug: 'qiche',
    description: '弯道超车，中国新能源汽车品牌引领全球绿色出行革命',
    icon: 'ri-car-line',
  },
  {
    id: 'jiaju-baihuo',
    name: '家居百货',
    slug: 'jiaju-baihuo',
    description: '提升生活品质，中国家居品牌用匠心设计装点每一个温馨的家',
    icon: 'ri-sofa-line',
  },
  {
    id: 'wenchuang',
    name: '文创潮玩',
    slug: 'wenchuang',
    description: '传统文化新表达，中国文创品牌让千年文明焕发全新生命力',
    icon: 'ri-palette-line',
  },
];